/* eslint no-unused-vars: 0  */
/* global $ */

/*
  Any custom project animations
*/
